module.exports = __webpack_public_path__ + "static/media/chat-primary.fafc0412.svg";